import { Badge } from '@sgme/ui';
import { IntlKey } from 'locales';
import { MultipleBadgeFieldMetadata } from 'models/forms/fields/multiple-badge-metadata';
import { FormattedMessage } from 'react-intl';
import { useFormFieldData } from 'routes/essential-workspace/components/form/use-form-field-data';

export function MultipleBadgeField({ id, labels, translationKey }: MultipleBadgeFieldMetadata) {
  const [codes] = useFormFieldData<string[]>(id, []);
  const hasCodes = codes.length > 0;

  if (!hasCodes) {
    return null;
  }

  const labelTranslationKey = translationKey ?? id;

  return (
    <div className="d-flex align-items-center gap-2 flex-wrap">
      <span className="text-secondary fs-12">
        <FormattedMessage id={`form.${labelTranslationKey}` as IntlKey} />
      </span>
      {codes.map(code => (
        <Badge key={code} purpose="outline" size="lg">
          <FormattedMessage id={`${labelTranslationKey}.${code}` as IntlKey} defaultMessage={labels[code] ?? code} />
        </Badge>
      ))}
    </div>
  );
}
